import CTACard from "@bmi-digital/components/cta-card";
import Grid from "@bmi-digital/components/grid";
import Section from "@bmi-digital/components/section";
import React from "react";
import { DefaultImage } from "@bmi-digital/components";
import { useTheme } from "@mui/material/styles";
import { getCTA } from "../../../components/link/utils";
import createImageProps from "../../../components/image/createImageProps";
import createVideoProps from "../../../components/video/createVideoProps";
import type { PromoCard } from "../../../components/Promo";
import type {
  ContactUsPageInfoCard,
  ProductListerPageInfoCard,
  SimplePageInfoCard
} from "../../../components/PageInfo";
import type { SiteData as SiteData } from "../../../components/Site";
import type { ProductDetailsPageData } from "../product-details-page";

export type PdpCardsProps = {
  resources: {
    pdpCards: readonly (
      | PromoCard
      | SimplePageInfoCard
      | ProductListerPageInfoCard
      | ContactUsPageInfoCard
    )[];
    pdpCardsTitle: NonNullable<ProductDetailsPageData["pdpCardsTitle"]>;
  };
  countryCode: SiteData["countryCode"];
};

const PdpCardsSection = ({
  resources: { pdpCards, pdpCardsTitle },
  countryCode
}: PdpCardsProps) => {
  const theme = useTheme();

  return (
    <Section
      backgroundColor="alabaster"
      className="PdpCardsSection"
      data-testid="pdp-cards-section"
    >
      <Section.Title>{pdpCardsTitle}</Section.Title>
      <Grid container spacing={3}>
        {pdpCards.map(
          ({ title, featuredVideo, featuredMedia, ...data }, index, cards) => {
            const cardTitle = title || ""; // TODO: DXB-7055 title can't be null
            const cta = getCTA(data, countryCode, cardTitle);
            return (
              <Grid
                key={`card-${index}`}
                xs={12}
                sm={6}
                md={4}
                lg={12 / Math.max(cards.length, 3)}
              >
                <CTACard
                  title={cardTitle}
                  media={
                    featuredVideo
                      ? createVideoProps(featuredVideo, theme)
                      : featuredMedia
                        ? createImageProps(featuredMedia, theme)
                        : {
                            component: DefaultImage
                          }
                  }
                  {...cta}
                />
              </Grid>
            );
          }
        )}
      </Grid>
    </Section>
  );
};

export default PdpCardsSection;
